import { render, staticRenderFns } from "./calledsTable.vue?vue&type=template&id=44e4131f&scoped=true"
import script from "./index.js?vue&type=script&lang=js&external"
export * from "./index.js?vue&type=script&lang=js&external"
import style0 from "./calledsTable.vue?vue&type=style&index=0&id=44e4131f&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44e4131f",
  null
  
)

export default component.exports